import { render, staticRenderFns } from "./HotelMealBookScreen.vue?vue&type=template&id=20fcef67&"
import script from "./HotelMealBookScreen.vue?vue&type=script&lang=ts&"
export * from "./HotelMealBookScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports